import React from 'react';

export const TablePaddingContext = React.createContext({});
